import { render, staticRenderFns } from "./Contract.vue?vue&type=template&id=b0ed268a&scoped=true"
import script from "./Contract.vue?vue&type=script&lang=js"
export * from "./Contract.vue?vue&type=script&lang=js"
import style0 from "./Contract.vue?vue&type=style&index=0&id=b0ed268a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0ed268a",
  null
  
)

export default component.exports